import React from "react";
import { cn } from "@/lib/utils";
import { fdrClass } from "@/lib/api";

export default function FDRPill({ difficulty, label, className, size = "sm" }) {
  const cls = fdrClass(difficulty);
  const sizeCls = size === "sm" ? "text-[10px] px-1.5 py-[3px]" : "text-xs px-2 py-1";
  return (
    <span
      className={cn(
        "inline-block rounded mono uppercase font-semibold tracking-wider",
        cls,
        sizeCls,
        className
      )}
    >
      {label}
    </span>
  );
}
